module.exports = __webpack_public_path__ + "static/story-e708e0508c917016ab8e24029e4ab93b.png";